import React, { useState } from "react"
import L10n from "lib/carrot-l10n"
import WizardWrapper from "components/views/atoms/forms/WizardWrapper"
import RequestCardHeader from "components/views/requestcard/RequestCardHeader"
import { Spacer } from "../atoms/Atoms"
import { Checkbox } from "../atoms/Checkbox"
import { Body } from "../atoms/Bodies"
// eslint-disable-next-line import/no-restricted-paths
import { MasterLayout } from "../atoms/layouts/MasterLayout"
import { BodyLayout } from "../atoms/layouts/BodyLayout"
import { useSelector } from "react-redux"
import { getIsUsa } from "reducers/userInfo"
import { useHistory } from "react-router"
import { getIsAvenuesMember, getIsNBAMember, getIsRomanHealthNYMandateMember, getIsWNBAMember } from "derivedSelectors"
import { RequestCardInformationMarkdown } from "components/views/requestcard/RequestCardInformationMarkdown"
import { H2, H4 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

// @ts-expect-error TS7006
const RequestCardInformation = (props) => {
  const isNBAMember = useSelector(getIsNBAMember)
  const isWNBAMember = useSelector(getIsWNBAMember)
  const isAvenuesMember = useSelector(getIsAvenuesMember)
  const isRomanHealthNYMandateMember = useSelector(getIsRomanHealthNYMandateMember)
  const [readInformation, setReadInformation] = useState(false)
  const isUsa = useSelector(getIsUsa)
  const history = useHistory()

  if (!isUsa) {
    history.push(props.requestCardPath + "/phone-number")
  }

  const onDone = () => {
    history.push(props.requestCardPath + "/mailing-address")
  }

  return (
    <MasterLayout header={<RequestCardHeader backRoute="/transactions" />}>
      <BodyLayout>
        <H4 variant="primary">{l`carrotCard.requestYourCarrotCard`}</H4>
        <WizardWrapper
          back
          backRoute="/transactions"
          backText={l`cancel`}
          done
          nextDisabled={!readInformation}
          doneText={l`next`}
          onDone={onDone}
        >
          <Spacer height={2} />
          <H2>
            <span id="request-card-information-header">{l`What to know before you use your Carrot Card®`}</span>
          </H2>
          <Spacer height={0.5} />
          <RequestCardInformationMarkdown
            source={
              isNBAMember
                ? l`carrotCard.request.cignaNbaInformation`
                : isWNBAMember
                ? l`carrotCard.request.wnbaInformation`
                : isAvenuesMember
                ? l`carrotCard.request.AvenuesInformation`
                : isRomanHealthNYMandateMember
                ? l`carrotCard.request.RomanHealthNYMandateInformation`
                : ""
            }
          />
          <Spacer height={2.5} />
          <label>
            <div className="flex flex-row ml1">
              {/*
               // @ts-expect-error TS7006 */}
              <Checkbox checked={readInformation} onChange={(e) => setReadInformation(e.target.checked)} />
              <div className="ml2">
                <Body color="black-80">
                  <RequestCardInformationMarkdown
                    source={
                      isNBAMember
                        ? l`carrotCard.request.cignaNbaAgreement`
                        : isWNBAMember
                        ? l`carrotCard.request.WnbaAgreement`
                        : isAvenuesMember
                        ? l`carrotCard.request.AvenuesAgreement`
                        : isRomanHealthNYMandateMember
                        ? l`carrotCard.request.RomanHealthNYMandateAgreement`
                        : ""
                    }
                  />
                </Body>
              </div>
            </div>
          </label>
          <Spacer height={1} />
        </WizardWrapper>
      </BodyLayout>
    </MasterLayout>
  )
}

export { RequestCardInformation }
